import { Amplify } from 'aws-amplify';
import { env } from '@/config';

export const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: env.COGNITO_USER_POOL_ID,
      userPoolClientId: env.COGNITO_USER_POOL_CLIENT_ID,
      // userPoolWebClientId: env.COGNITO_USER_POOL_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: env.COGNITO_DOMAIN,
          scopes: ['openid', 'profile', 'email'],
          redirectSignIn: [env.REDIRECT_SIGNIN],
          redirectSignOut: [env.REDIRECT_SIGNOUT],
          responseType: "code" as "token" | "code",
        },
        username: true,
        email: true,
        phone: false,
      }
    }
  }
};

export const configureAmplify = (): void => {
  Amplify.configure(amplifyConfig);
};
